import PropTypes from 'prop-types';
import React from 'react';

class Section extends React.PureComponent {

  render() {
    const { title, children, color, className, janchorId } = this.props;

    return (
      <div className={`cdash-section ${color} ${className}`}>
        <h2 id={janchorId || undefined} className="cdash-section-title">{title}</h2>
        <div className="cdash-section-content">
          {children}
        </div>
      </div>
    );
  }

}

Section.propTypes = {
  title: PropTypes.string.isRequired,
  className: PropTypes.string,
  children: PropTypes.node,
  color: PropTypes.oneOf(['purple', 'pink', 'orange', 'blue', 'gray']),
  janchorId: PropTypes.string,
};

Section.defaultProps = {
  color: 'gray',
  className: '',
  janchorId: null,
};

export default Section;
